import { render, staticRenderFns } from "./AddNewAccessory.vue?vue&type=template&id=55adc1b9&scoped=true&"
import script from "./AddNewAccessory.vue?vue&type=script&lang=js&"
export * from "./AddNewAccessory.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAccessory.vue?vue&type=style&index=0&id=55adc1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55adc1b9",
  null
  
)

export default component.exports